<template>
  <div>
    <div class="header">
      <a-breadcrumb class="breadcrumb">
        <a-breadcrumb-item>项目</a-breadcrumb-item>
        <!-- <a-breadcrumb-item><router-link :to="{ path: '/meeting/list' }">已排会</router-link></a-breadcrumb-item> -->
        <a-breadcrumb-item>项目相关会议列表</a-breadcrumb-item>
      </a-breadcrumb>

      <a-tabs v-if="list && list.length > 0" :active-key="activeItem" @change="change">
        <a @click="voteVisible = true" v-if="permissionVote" slot="tabBarExtraContent">Vote记录</a>
        <a-tab-pane v-for="(i, index) in titleList" :key="index" :tab="i"></a-tab-pane>
      </a-tabs>
    </div>
    <div class="content">
      <meeting-item 
        :company-id="companyId" 
        v-for="(i, index) in list" 
        :key="index" 
        ref="meetingItem" 
        :info="i" 
        @refresh="refresh"
        />
    </div>
    <vote-list-drawer v-if="voteVisible" :visible.sync="voteVisible" :projectId="companyId"> </vote-list-drawer>
    <template v-if="list.length === 0">
      <a-skeleton v-for="i in 5" :key="i" :paragraph="{ rows: 4 }" active />
    </template>
  </div>
</template>
<style lang="less" scoped>
.header {
  background: #fff;
  position: fixed;
  top: 46px;
  left: 0;
  right: 0;
  z-index: 1;
  padding: 0 20px;
}
/deep/ .ant-tabs-bar {
  margin: 0;
}
.content {
  margin-top: 70px;
}
.breadcrumb {
  margin: 10px;
}
</style>

<script>
import MeetingItem from '@/components/meeting/meetingDetail/meetingItem.vue';
import throttle from 'lodash/throttle';
import debounce from 'lodash/debounce';
import moment from 'moment';
import { meetProjectList } from '@/api/meeting';
import { meetingGoalMap } from '@/utils/meeting';
import { getDetail } from '@/api/project';
import voteListDrawer from '@/components/project/voteListDrawer';

export default {
  components: {
    MeetingItem: MeetingItem,
    voteListDrawer
  },
  data() {
    return {
      list: [],
      activeItem: 1,
      isListenScroll: true,
      voteVisible: false,
      permissionVote: true
    };
  },
  computed: {
    titleList() {
      return this.list.map(i => {
        return `${moment(i.baseInfo.startTime * 1000).format('YYYY.MM.DD')}-${meetingGoalMap[i.baseInfo.meetingGoal]}`;
      });
    },
    companyId() {
      return parseInt(this.$route.query.companyId);
    },
    projectId() {
      return parseInt(this.$route.query.meetingProjectId);
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollListen);
    window.addEventListener('scroll', this.scrollend);
    meetProjectList({ companyId: this.companyId }).then(res => {
      if (res.code === 200) {
        this.list = res.data;
        this.list.forEach((i, index) => {
          i.baseInfo.companyId = this.companyId;
          if (parseInt(this.projectId) === i.baseInfo.id) {
            this.change(index);
          }
        });
      }
    });
    this.getCompanyDetail();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollListen);
    window.removeEventListener('scroll', this.scrollend);
  },
  methods: {
    refresh() {
      meetProjectList({ companyId: this.companyId }).then(res => {
        if (res.code === 200) {
          this.list = res.data;
          this.list.forEach((i, index) => {
            i.baseInfo.companyId = this.companyId;
            if (parseInt(this.projectId) === i.baseInfo.id) {
              this.change(index);
            }
          });
        }
      });
    },
    change(index) {
      this.$ga.gaUploadCustomEvent('会议详情-切换会议');
      this.activeItem = index;
      this.scrolltoItem(index);
    },
    scrolltoItem(index) {
      this.isListenScroll = false;
      this.$nextTick(() => {
        this.$refs.meetingItem[index].$el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
      });
    },

    async getCompanyDetail() {
      try {
        let res = await getDetail(this.companyId);
        if (res.code === 200) {
          // this.projectName = res.data.base.name;
          this.permissionVote = res.data.showVotes;
        }
      } catch (e) {
        // this.$message.error(e.message);
      }
    },
    // 滑动结束时 触发
    scrollend: debounce(function() {
      this.isListenScroll = true;
    }, 100),
    // 滑动过程中触发
    scrollListen: throttle(function() {
      if (!this.isListenScroll || !this.$refs.meetingItem) {
        return;
      }
      let mid = screen.availHeight / 2;
      for (let i = 0; i < this.$refs.meetingItem.length; i++) {
        let rect = this.$refs.meetingItem[i].$el.getBoundingClientRect();
        if (rect.top <= mid && rect.height + rect.top >= mid) {
          this.activeItem = i;
          i = this.list.length;
        }
      }
    }, 50)
  }
};
</script>

<style></style>
